import type { StateView } from '@quiz/shared';
import type { PlayerSession } from '../lib/session.js';
import { Card, Leaderboard } from '../components/ui.js';

export function BreakScreen({
  session,
  state,
}: {
  session: PlayerSession;
  state: StateView;
}) {
  const finishedIndex = state.round?.index ?? -1;
  const next = session.quiz.rounds[finishedIndex + 1];

  return (
    <div className="flex flex-1 flex-col gap-4">
      <Card className="text-center">
        <p className="text-xs uppercase tracking-wide text-muted">End of</p>
        <p className="mt-1 text-2xl font-semibold">{state.round?.title}</p>
        <p className="mt-4 text-5xl font-bold tabular-nums">{state.you.score}</p>
        <p className="text-sm text-muted">points so far</p>
      </Card>

      {state.leaderboard && (
        <Leaderboard rows={state.leaderboard} highlightPlayerId={session.playerId} />
      )}

      {next ? (
        <Card className="text-center">
          <p className="text-xs uppercase tracking-wide text-muted">Coming up</p>
          <p className="mt-1 text-xl font-semibold text-sky">{next.title}</p>
          <p className="mt-1 text-sm text-muted">{next.questionCount} questions</p>
        </Card>
      ) : (
        <p className="text-center text-muted">That was the last round. Hold tight…</p>
      )}
    </div>
  );
}
